<template>
    <div @click="open('https://catuxolessons.talentlms.com/catalog/index?utm_source=cat-uxo')" class="call-to-action call-to-action--with-border bg-white border-radius p-4">
        <div class="call-to-action__content">
            <div class="call-to-action__heading mb-2">Explore our training lessons.</div>
            <p class="call-to-action__paragraph mb-12px t-navy">For a better understanding of EOD doctrine,
                access our online EOD lessons and receive a CAT-UXO certificate (EOD Level 1 to 3) to
                confirm your technical knowledge and competence.</p>
            <a class="btn-icon-text btn-navy" target="_blank" href="https://catuxolessons.talentlms.com/catalog/index?utm_source=cat-uxo">Find out more <i class="icon icon__arrow-right-navy"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CatUxoCallToActionOutline",
        methods: {
            open(url) {
                window.open(url);
            }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/CallToActionOutline.vue